export function numberToKorean(num) {
  // 입력값 정리 (콤마 제거/trim)
  const cleaned = String(num).replace(/,/g, "").trim();

  // 0인 경우(예: 0, "0", "000")는 독음을 표시하지 않음
  if (cleaned === "" || !/^[0-9]+$/.test(cleaned) || Number(cleaned) === 0) return "";

  const units = ["", "만", "억", "조"];
  const nums = ["영", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구"];
  const tens = ["", "십", "백", "천"];

  let number = Number(cleaned);
  let result = "";
  let unitIndex = 0;

  while (number > 0) {
    let part = number % 10000;
    let partResult = "";

    for (let i = 0; i < 4; i++) {
      if (part % 10 > 0) {
        partResult =
          nums[part % 10] + tens[i] + partResult;
      }
      part = Math.floor(part / 10);
    }

    if (partResult) {
      result = partResult + units[unitIndex] + " " + result;
    }

    number = Math.floor(number / 10000);
    unitIndex++;
  }

  return result.trim() + " 원";
}
